/**
 * Camera visit report model
 */
export class CameraEvent {
  userId: string;
  userName: string;
  companyId: string;
  id: string;
  alert?: {
    id: string;
    time?: string;
    activationGroup?: number;
    activationNode?: number;
    deviceType?: string;
    connTimeLimit?: number;
  };

  visitStarted: string;
  visitEnd: string;
  visitSnoozedAt: string;
  visitResumedAt: string;
  camera: {
    cameraId: string;
    locationId?: string;
    displayName: string;
    cameraGroupId: string;
    visitType: string;
    anonymizedPropExists?: boolean;
    anonymizedStatus?: boolean;

    //Nightowl specific properties
    userConnectedAt?: string;
    userDisconnectedAt?: string;
    anonymizationDisabledAt?: string;
    anonymizationEnabledAt?: string;
    speakerEnabledAt?: string;
    speakerDisabledAt?: string;
    microphoneEnabledAt?: string;
    microphoneDisabledAt?: string;
    furnitureViewedAt?: string;
  };

  origonCall?: {
    origonId: string;
    origonName: string;
    callTime: string;
  }[];

  expanded?: boolean;
}

/**
 * Lock event report model
 */
export class LockEvent {
  userId: string;
  companyId: string;
  locationId: string;
  mobileId: string;
  mobileNumber: string;
  userName: string;
  lockId: string;
  lockedDoorTypeId: number;
  deviceId: string;
  lockName: string;
  eventType: string;
  createdTime: Date;
  expanded?: boolean;
}

export interface IGetReportFilterOptionsResponse {
  alertRoutes: IFilterOption[];
  basestations: IFilterOption[];
  devices: IFilterOption[];
  locations: IFilterOption[];
  personnel: IFilterOption[];
  receiverGroups: IFilterOption[];
  deviceTypes: string[];
  nfcTags: IFilterOption[];
}

export interface IFilterOption {
  id: string;
  name: string;
}

export type ReportDataType = CameraEvent[] | LockEvent[] | any[]; // Type "any" means alerts
export type ReportType = "Alert" | "CameraVisit" | "LockEvent";


/**
 * Camera visit types shown in the "Event" column of the camera event report.
 * The values match the visit types the server returns in CameraEvent.camera.visitType
 * and are sent back as such in the camera visit query.
 */
export enum CameraVisitType {
  Scheduled = "Scheduled",
  VisitOnAlert = "Visit on alert",
  Camera24_7 = "24/7 camera",
}

/**
 * Options of the camera event report visit type (event) filter. The translation keys are
 * the same ones the event table resolves from the visit type with the langCode pipe.
 */
export const CAMERA_VISIT_TYPE_FILTER_OPTIONS: { id: CameraVisitType; translationKey: string }[] = [
  { id: CameraVisitType.Scheduled, translationKey: "SCHEDULED" },
  { id: CameraVisitType.VisitOnAlert, translationKey: "VISIT_ON_ALERT" },
  { id: CameraVisitType.Camera24_7, translationKey: "24_7_CAMERA" },
];
